import { useRouteError } from 'react-router-dom';
import useI18n from "../../hooks/useI18n";

import './style.scss';

export default function ErrorPage({ geoBlocking }: { geoBlocking?: boolean }) {
  const error = useRouteError() as Error;
  const { t } = useI18n();

  return (
    <div className="ErrorPage" id="error-page">
      <h1>{t("ErrorPage.title")}</h1>
      <p>{t("ErrorPage.description")}</p>
      <pre>
        {!geoBlocking
          ? error.message || JSON.stringify(error)
          : t("ErrorPage.geoBlocking.message")}
      </pre>
    </div>
  );
};
